import React, { useState, useEffect } from "react";
import { faEye, faEyeSlash, faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import Blue_Round_Btn from "../../common-components/common-btn/blue_round_btn/Blue_Round_Btn";
import Red_Round_Btn from "../../common-components/common-btn/red_round_btn/Red_Round_Btn";
import "./Reset_Password.css";
import { useNavigate } from "react-router-dom";
import { sendMobileOtp, verifyOtp } from "../../../features/auth/authSlice";
import { useDispatch } from "react-redux";

const Reset_Password = ({ email, contact, setEmail, setContact, ...props }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);
  const [showSuccessModal, setShowSucsessModal] = useState(false);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const [otp, setOtp] = useState(["", "", "", ""]);

  const handleInputChange = (e, index) => {
    const value = e.target.value;
    if (isNaN(value) || value.length > 1) {
      return;
    }

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Focus the next input field
    if (value && index < otp.length - 1) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleKeyDown = async (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  const [showOtpDiv, setShowOtpDiv] = useState(false);
  const [timer, setTImer] = useState(30);
  const [disabled, setDisables] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch()

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    let interval;
    if (disabled) {
      interval = setInterval(() => {
        setTImer((prev) => {
          if (prev === 1) {
            clearInterval(interval);
            setDisables(false);
            return 0;
          }
          return prev - 1;
        });
      }, 2000);
    }
    return () => clearInterval(interval);
  }, [disabled]);

  const user_data = {};




  const resendCode = async () => {
    reset("otp", "");
    setOtp(["", "", "", ""]);
    const data = {
      email: email,
      contact_no: contact,
    };
    if (disabled) return;
    const res = await dispatch(sendMobileOtp(data));
    setDisables(true);
    setTImer(90);
  };

  const validateOTp = async () => {
    const data = {
      email: email,
      contact_no: contact,
      otp: otp?.join(""),
    };

    const verify = await dispatch(verifyOtp(data));
    if (verify.meta?.requestStatus === "fulfilled") {
      navigate("/set-new-password")
      setDisables(true)
      setShowOtpDiv(false);
      setOtp(["", "", "", ""]);
    } else if (verify.meta?.requestStatus === "rejected") {
      if (verify.payload?.errors?.otp) {
        setError("otp", { type: "custom", message: verify.payload.errors.otp.msg });
      } else if (verify.payload?.message) {
        console.log(verify.payload.message);
        setError("otp", { type: "custom", message: verify.payload?.errors });
      }
    }
  };

  const onSubmit = async (data) => {
    const validator = require("validator");
    if (validator.isEmail(data.email_or_contact)) {
      setEmail(data.email_or_contact);
      user_data.email = data.email_or_contact;
      setContact('');
    } else {
      setContact(data.email_or_contact);
      user_data.contact_no = data.email_or_contact;
      setEmail("");
    }

    const res = await dispatch(sendMobileOtp(user_data));

    if (res.meta?.requestStatus === "fulfilled") {
      user_data.email = data.email;
      setTImer(90);
      setDisables(true);
      setShowOtpDiv(true);
    } else if (res.meta?.requestStatus === "rejected") {
      setError("email_or_contact", {
        type: "custom",
        message: "Email Address / Mobile  Number not Found",
      });
    }
  };


   useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className="Login Reset_Password">
      <div className="container">
        <div className="content_div">
          <div className="row">
            <div className="col-lg-6 my-auto">
              <div className="all_form_holder">

                <div className="goto_home_div" onClick={() => navigate("/")}>
                  <FontAwesomeIcon icon={faHome} className="home_icon" />
                </div>

                {!showOtpDiv && (
                  <div className="common_form_div">
                    <p className="title_text">Reset Your Password</p>
                    <p className="subtitle_text">
                      {/* Check your email for a password reset link */}
                      Check your email / Mobile Number for a password otp

                    </p>

                    <div className="login_div">
                      <div className="login_form_div">
                        <Form>
                          <Form.Group className="input_group">
                            <Form.Label>Email / Mobile</Form.Label>
                            <Form.Control
                              type="text"
                              name="email_or_contact"
                              placeholder="Enter Email / Mobile"
                              {...register("email_or_contact", {
                                required: "Credentials required",
                              })}
                            />
                            {errors?.email_or_contact && (
                              <sup className="text-danger">
                                {errors?.email_or_contact?.message}
                              </sup>
                            )}
                          </Form.Group>

                          <div className="btn_holder">
                            <Red_Round_Btn
                              btnText={"Cancel"}
                              onClick={() => navigate("/login")}
                            />
                            <Blue_Round_Btn
                              btnText="Submit"
                              // onClick={() => setShowOtpDiv(true)}
                              onClick={handleSubmit(onSubmit)}
                            />
                          </div>
                        </Form>
                      </div>
                    </div>
                  </div>
                )}

                {showOtpDiv && (
                  <div className="common_form_div">
                    <p className="title_text">OTP has been Sent</p>
                    <p className="subtitle_text">
                      to the Email / Mobile Number
                    </p>

                    <div className="login_div">
                      <div className="login_form_div">
                        <div className="Otp-field-holder">
                          {otp?.map((value, index) => (
                            <Form.Control
                              key={index}
                              type="text"
                              className="otp-field"
                              maxLength="1"
                              value={value}
                              id={`otp-${index}`}
                              onChange={(e) => handleInputChange(e, index)}
                              onKeyDown={(e) => handleKeyDown(e, index)}
                            />
                          ))}
                        </div>
                        {errors.otp && (
                          <div style={{ color: "red" }}>{errors.otp.message}</div>
                        )}

                        <div className="btns_holder">
                          {disabled ? (
                            <>
                              <p className="link_text">
                                Resend Code in {timer} seconds
                              </p>

                              <Blue_Round_Btn
                                btnText={"Submit"}
                                // onClick={() => {
                                //   navigate("/set-new-password");
                                // }}
                                onClick={() => validateOTp()}
                              />
                            </>
                          ) :
                            <p className="link_text" onClick={() => { resendCode() }}>
                              Resend Code
                            </p>
                          }

                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="login_img_holder">
                <img
                  src="/assets/images/login/rightimg.png"
                  className="right_img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reset_Password;
